import { Tab, Tabs } from '@material-ui/core';
import {
  // RepairerInfo,
  UserRole,
} from 'app/core/api/user/api-user.types';
import styledMixins from 'app/styles/styledMixins';
import React, { useState, useEffect } from 'react';
import { appEnv, AppVariant } from 'app/core/environment';
import styled from 'styled-components/macro';
import { useUrlParams } from 'app/tools/hooks/misc-hooks';
import {
  useRepairerCase,
  // useSearchRepairers,
} from 'app/core/api/repairer/api-repairer';
import ProfileDrawer from 'app/consumer-app/views/repairer-profile/ProfileDrawer';
import Chat from './Chat';
import QuoteTrackingDrawer from './quote-tracking-drawer';
import TaskInfo from './TaskInfo';

const TasksTabs = styled(Tabs)`
  ${styledMixins.softShadow}
`;

const TabPanel: React.FC<{ index: number; activeTab: number }> = ({
  children,
  index,
  activeTab,
}) => (
  <div
    role="tabpanel"
    id={`wrapped-tabpanel-${index}`}
    aria-labelledby={`wrapped-tab-${index}`}
    css={`
      flex: 1 1 100%;
      display: ${activeTab === index ? 'flex' : 'none'};
    `}
  >
    {activeTab === index && children}
  </div>
);

type Props = {
  userRole: UserRole;
};
export default function Tasks({ userRole }: Props): JSX.Element {
  const { id } = useUrlParams(['id']);
  const { resource: repairCase } = useRepairerCase(id);
  const [activeTab, setActiveTab] = useState(0);
  const [isShowTracking, SetIsShowTracking] = useState<boolean>(true);
  const isConsumer = appEnv.APP_VARIANT === AppVariant.CONSUMER;
  const onTabChange = (val: unknown) => {
    setActiveTab(val as number);
  };

  useEffect(() => {
    if (isConsumer) {
      if (repairCase?.caseStatus === 'collected') {
        setActiveTab(2);
      }
      // if (repairCase?.paymentStatus === 'None') {
      //   SetIsShowTracking(false);
      // }
    } else if (repairCase?.caseStatus === 'new') {
      SetIsShowTracking(false);
    }
  }, [isConsumer, repairCase]);

  return (
    <>
      {isConsumer && (
        <>
          <TasksTabs
            value={activeTab}
            onChange={(e, val) => onTabChange(val)}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab
              value={1}
              label="Task Info"
              style={{ textTransform: 'none' }}
            />
            {isShowTracking && (
              <Tab
                value={2}
                label="Task Status"
                style={{ textTransform: 'none' }}
              />
            )}
            <Tab
              value={0}
              label="Chat"
              style={{ textTransform: 'none' }}
            />
            <Tab
              value={3}
              label="Details"
              style={{ textTransform: 'none' }}
            />
          </TasksTabs>
          <TabPanel index={0} {...{ activeTab }}>
            <Chat
              userRole={userRole}
              onTabChange={onTabChange}
              SetIsShowTracking={SetIsShowTracking}
            />
          </TabPanel>
          <TabPanel index={1} {...{ activeTab }}>
            <TaskInfo />
          </TabPanel>
          <TabPanel index={2} {...{ activeTab }}>
            <QuoteTrackingDrawer />
          </TabPanel>
          <TabPanel index={3} {...{ activeTab }}>
            <ProfileDrawer />
          </TabPanel>
        </>
      )}
      {!isConsumer && (
        <>
          <TasksTabs
            value={activeTab}
            onChange={(e, val) => onTabChange(val)}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab
              value={0}
              label="Task Info"
              style={{ textTransform: 'none' }}
            />
            {isShowTracking && (
              <Tab
                value={1}
                label="Task Status"
                style={{ textTransform: 'none' }}
              />
            )}
            <Tab
              value={2}
              label="Chat"
              style={{ textTransform: 'none' }}
            />
          </TasksTabs>
          <TabPanel index={2} {...{ activeTab }}>
            <Chat
              userRole={userRole}
              onTabChange={onTabChange}
              SetIsShowTracking={SetIsShowTracking}
            />
          </TabPanel>
          <TabPanel index={0} {...{ activeTab }}>
            <TaskInfo />
          </TabPanel>
          <TabPanel index={1} {...{ activeTab }}>
            <QuoteTrackingDrawer />
          </TabPanel>
        </>
      )}
    </>
  );
}
